import { Component, OnInit } from '@angular/core';
import validationEngine from 'devextreme/ui/validation_engine';
import { DevExtremeModule } from 'devextreme-angular';
import { AppInformationService, AuthService, CdrUnitOfWork } from 'src/app/core/core.module';
import { Dumpster } from 'src/app/core/model/dumpster';
import { DumpsterCategory } from 'src/app/core/model/dumpster-category';
import { TimeEntry } from 'src/app/core/model/time-entry';
import { TimeType } from 'src/app/core/model/time-type';
import { User } from 'src/app/core/model/user';
import { BaseDialogComponent } from 'src/app/shared/base-dialog/base-dialog.component';

@Component({
    selector: 'app-time-entry-dialog',
    templateUrl: './time-entry-dialog.component.html',
    styleUrls: ['./time-entry-dialog.component.scss'],
    standalone: true,
    imports: [DevExtremeModule]
})
export class TimeEntryDialogComponent extends BaseDialogComponent<any> implements OnInit {
    timeEntry: TimeEntry;
    date: Date;
    timeTypes: TimeType[];
    users: User[];

    constructor(private auth: AuthService, private uow: CdrUnitOfWork, private appInfo: AppInformationService) {
        super();
    }

    async ngOnInit() {
        this.timeTypes = await this.uow.timeTypes.whereActive('displayOrder, name');
        this.users = await this.uow.getActiveUsers();
        if (!this.timeEntry) {
            this.timeEntry = this.uow.timeEntries.createEntity();
            this.timeEntry.created = new Date();
            this.timeEntry.createdBy = this.auth.userValue.userName;
            if (!!this.date) {
                this.timeEntry.entryDate = this.date;
            }
            this.timeEntry.duration = null;
        }
    }

    save = async () => {
        const success = this.valid();
        if (!success) return;

        this.appInfo.pleaseWaitShow();
        await this.uow.commit();
        this.appInfo.pleaseWaitHide();
        this.hide({ success: true, value: this.timeEntry });
    };

    cancel = async () => {
        this.uow.rollback();
        this.hide({ success: false });
    };

    valid() {
        const groupConfig = validationEngine.getGroupConfig('mainValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('mainValidationGroup');
            return result.isValid;
        } else return false;
    }
}
